<ion-content [fullscreen]="true">
    <header>
        <h1>Políticas de privacidade</h1>
        <ion-icon name="close-outline" (click)="modalService.dismiss()"></ion-icon>
    </header>

    <main>
        <iframe src='https://grupotrigo.alphacode.com.br/PoliticadePrivacidade-GrupoTrigo-04-ago-2025.pdf' width='100%' height='100%' frameborder='0'></iframe>
    </main>
</ion-content>
